// extracted by mini-css-extract-plugin
export default {"container":"Disaster_container__PKn88"};